// export const API_NAPBUS = 'http://localhost:5000/api';
export const API_NAPBUS = process.env.REACT_APP_API_NAPBUS ?? 'https://back-buses.napnegocios.com/api';
// export const API_SOCKET = 'http://localhost:5000';
export const API_SOCKET = process.env.REACT_APP_API_SOCKET ?? 'https://back-buses.napnegocios.com';
// export const API_NAPBUS = process.env.REACT_APP_  API_NAPBUS ?? 'https://back-buses.napnegocios.com/api';
// export const API_COBRANZAS = 'http://192.168.1.22:7000/api';
export const API_COBRANZAS = process.env.REACT_APP_API_COBRANZAS ?? 'https://back.pagos.napnegocios.com/api';
